import { Button } from '@innovyze/stylovyze';
import React from 'react';

import { useGlobalization } from '@Translations/useGlobalization';
import useEsriLogin from './useEsriLogin';

export interface AuthenticateButtonProps {
	disabled?: boolean;
}

export default function AuthenticateButton({
	disabled,
}: AuthenticateButtonProps) {
	const { t } = useGlobalization();

	const { handleAuthToEsri } = useEsriLogin();
	return (
		<Button
			dataCy="authenticate-button"
			variant="contained"
			color="primary"
			disabled={disabled}
			onClick={() => handleAuthToEsri()}
			style={{ height: 36 }}>
			{t('Authenticate')}
		</Button>
	);
}
